import FilterResultsHeadline from './FilterResultsHeadline';
import './FilterResultsHeadline.scss';

export default FilterResultsHeadline;